module.exports = __webpack_public_path__ + "img/dangdang.d60d2735.webp";